import {
    RangeSlider as RangeSliderChakra,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderThumb,
    Flex,
    Text,
  } from '@chakra-ui/react'
  
type  RangeSliderProps = {
    defaultvalues: Array<number>;
    onChange: (value: number[]) => void;
    labelStart?: string;
    labelEnd?: string;
};

const RangeSlider = ({defaultvalues, onChange, labelStart, labelEnd}: RangeSliderProps) => {
    return (
        <RangeSliderChakra onChangeEnd={onChange} defaultValue={defaultvalues}>
        <RangeSliderTrack>
          <RangeSliderFilledTrack  bgColor='#62AEEB' />
        </RangeSliderTrack>
        <Flex justifyContent='space-between' marginBottom='35px'>
            <Text fontWeight={400} fontFamily='Montserrat' fontSize='15px'>{labelStart}</Text>
            <Text fontWeight={400} fontFamily='Montserrat' fontSize='15px'>{labelEnd}</Text>
        </Flex>
        <RangeSliderThumb bgColor='#3498FE' index={0} />
        <RangeSliderThumb bgColor='#3498FE' index={1} />
      </RangeSliderChakra>
    )
};

export { RangeSlider };
